// Shared helpers for the Overview / News / Competitors renderers (PDF + screen).

export const stripHtml = (s?: string | null): string =>
    (s ?? '')
        .replace(/<[^>]+>/g, '')
        .replace(/&nbsp;/g, ' ')
        .replace(/\s+/g, ' ')
        .trim();

export const splitBullets = (s: string): string[] => {
    const parts = s
        .split(/\s*[-·•]\s+/)
        .map((p) => p.trim())
        .filter(Boolean);
    return parts.length > 1 ? parts : [s];
};

export const truncateText = (s: string, max: number): string => {
    const clean = s.trim();
    if (clean.length <= max) return clean;
    const cut = clean.slice(0, max);
    const lastSpace = cut.lastIndexOf(' ');
    return (lastSpace > max * 0.6 ? cut.slice(0, lastSpace) : cut).trimEnd() + '…';
};

// "Economic Times" → "ET", "VCCircle" → "VC", "Manufacturing Frontier" → "MF"
export const sourceInitials = (name: string): string => {
    const clean = name.trim();
    if (!clean) return '—';
    const words = clean.split(/\s+/).filter(Boolean);
    if (words.length === 1) {
        // Single word — take first two consonants/uppercase letters where possible.
        const w = words[0];
        const upper = w.match(/[A-Z]/g) ?? [];
        if (upper.length >= 2) return upper.slice(0, 2).join('');
        return w.slice(0, 2).toUpperCase();
    }
    return words
        .slice(0, 2)
        .map((w) => w[0]?.toUpperCase() ?? '')
        .join('');
};

export const sentimentTone = (s: string | undefined | null): 'pos' | 'neg' | 'neutral' => {
    const v = (s ?? '').toLowerCase();
    if (v === 'positive') return 'pos';
    if (v === 'negative') return 'neg';
    return 'neutral';
};
